import { noop } from "lodash-es";

export function neverResolve<T>(): Promise<T> {
  return new Promise(noop);
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export async function asyncNoop() {}

/**
 * usage: ensureResolve(resolver=>{... call resolver() or not ...}) returns a Promise that is guaranteed to resolve
 */
export function ensureResolve(fun: (resolver: () => () => void) => void) {
  return new Promise<void>((resolve) => {
    let used = false;
    fun(() => {
      used = true;
      return resolve;
    });
    if (!used) {
      resolve();
    }
  });
}

export function ignorePromise<T extends unknown[]>(
  func: (...args: T) => Promise<unknown>,
): (...args: T) => void {
  return (...args) => void func(...args);
}
